import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ad1bd0a3e66ea4788c3572dbb2f9c5cf4b from "./generated-908ba73b-8b56-4c82-8a1b-06e0a46234c2.json";

import a55d88d712e41a1a4dea896734c70727bb from "./generated-2bb77ffc-1a19-40f3-bcc6-2965d0b1ed88.json";

import a5a92128ca389a1181f2895ce2b853ceab from "./generated-92b16546-51a9-4d6e-be45-46af939e57da.json";

import a5cc6d05308b1957b62fe4c0fa5fd5c51b from "./generated-c76a5118-d490-412c-8774-b2fb398636a9.json";

import ac211e988d1db9adcc37dd90e7ebe81ceb from "./generated-0ba124de-9843-4b26-a170-c7494904625f.json";

import a9217ed2a3d9b26205e63d627738ef58fb from "./generated-726eb059-9f1e-4d77-aae0-288c3c75a5ca.json";

import a5f7d899a5c8d833a2afdd60d583bc499b from "./generated-029ffcd0-4103-433d-9e03-93547a95238b.json";

import a5bcbbebd6053ae1a32d7024f4282ba0fb from "./generated-4ab06952-1b81-4d1f-90cf-fef35567d462.json";

import ac74b8732f411667ca541d5fbdb712c2cb from "./generated-7ad922e6-f83c-4dbd-8ba0-68628897e39a.json";

import ab911e223e55314e27179f826ed0a9543b from "./generated-3cf5c07b-09ef-4f1e-afc6-0eb0ea895210.json";

import af8095dff9a4a9da0ccfc37f323c46458b from "./generated-3b2e0381-a2ed-4fb4-a454-150e799ecce3.json";

import a33a8f42c49d6b4ffb685a40f45db14ecb from "./generated-c58609ec-4b26-4bb7-a83c-77776a66262d.json";

import aa50d04b2d1f169988c02f851c56c6331b from "./generated-0f801d77-6c42-4ef3-8f30-66e85fc3c3ae.json";

import adf0ef04e748e7bd9642d4501fecbb672b from "./generated-5c395264-01a5-45fc-99d8-b69d7cea1d16.json";

import a76c7952e5d01b0b479d68cf510935ca8b from "./generated-b6a97959-9267-44ff-ab6f-e693c495b6bc.json";

import a053cfc2292993fbf04451532d75c40dcb from "./generated-2e2f68d5-d53b-490a-a3d8-1fca0cecf4bb.json";

import af530a404dcd24f143772858f6d2d2da9b from "./generated-308e3fa8-fb05-4fdf-8b7c-9b4f424950a4.json";

import ab25e8f7a07a94c27a728ab420332b3b4b from "./generated-5ddd26ef-3f68-4aa9-bee0-4aac7f13dca9.json";

import a2460ae999c06a8be69ac7d6c710b10b5b from "./generated-56969c90-0f7e-4a75-a1b4-40218f5e3bc6.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ad1bd0a3e66ea4788c3572dbb2f9c5cf4b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a55d88d712e41a1a4dea896734c70727bb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a5a92128ca389a1181f2895ce2b853ceab);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a5cc6d05308b1957b62fe4c0fa5fd5c51b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ac211e988d1db9adcc37dd90e7ebe81ceb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9217ed2a3d9b26205e63d627738ef58fb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a5f7d899a5c8d833a2afdd60d583bc499b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a5bcbbebd6053ae1a32d7024f4282ba0fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ac74b8732f411667ca541d5fbdb712c2cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ab911e223e55314e27179f826ed0a9543b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(af8095dff9a4a9da0ccfc37f323c46458b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a33a8f42c49d6b4ffb685a40f45db14ecb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aa50d04b2d1f169988c02f851c56c6331b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(adf0ef04e748e7bd9642d4501fecbb672b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a76c7952e5d01b0b479d68cf510935ca8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a053cfc2292993fbf04451532d75c40dcb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af530a404dcd24f143772858f6d2d2da9b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ab25e8f7a07a94c27a728ab420332b3b4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a2460ae999c06a8be69ac7d6c710b10b5b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af530a404dcd24f143772858f6d2d2da9b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */